import React from "react";
/** Components Import */
// import { QRCodeCanvas } from "qrcode.react";
import QrCode from "qrcode.react";
import { Box, Card, CardContent } from "@mui/material";

function QrCreator({
  value = "", // json type string
}) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        sx={{
          border: 1,
          borderRadius: "10px",
          borderColor: "divider",
          p: 2,
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <QrCode value={value} size={160} />
      </Box>
    </Box>
  );
}

export default QrCreator;
